import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  missing: {
    color: theme.palette.custom.ds.grayscales.gr600,
    fontSize: `${theme.typography.pxToRem(12)}`
  }
}));
